import React from 'react';
import { useSelector } from 'react-redux';

import { FeatureFlag } from '@swf/core/enums';
import useFeature from '@swf/core/hooks/useFeature';
import { select } from '@swf/core/store';
import type { WidgetFC } from '@swf/core/types/Widget';
import { CommunityFooter, HelpContainer, Home, HomeSkeleton } from '@swf/help';

import { helpCenterHomeWidgetModel, useHelpCenterHomeWidget } from './model';

// TODO: may need to remove <Router> after remove the old widget/components, when we have a new tempalte
const HelpCenterWidget: WidgetFC = () => {
  const { widgetSelect } = useHelpCenterHomeWidget();
  const announcements = useSelector(widgetSelect.announcements);
  const categories = useSelector(widgetSelect.categories);
  const suggestedArticlesType = useSelector(widgetSelect.suggestedArticlesType);
  const suggestedArticles = useSelector(widgetSelect.suggestedArticles);
  const isEmbedded = useSelector(select.site.isEmbedded);
  const showVegasContent = useSelector(select.site.showVegasContent);
  const showCommunityForum = useFeature(FeatureFlag.CommunityForum);
  const showCommunityFooter = showCommunityForum && !showVegasContent && !isEmbedded;

  const hasPreloaded = useSelector(widgetSelect.hasPreloaded);
  const isLoading = useSelector(widgetSelect.isLoading);

  return (
    <>
      <HelpContainer
        announcements={announcements}
        isLoading={isLoading}
        isPreloaded={hasPreloaded}
        preloader={<HomeSkeleton />}
        showTitle
      >
        <Home
          categories={categories}
          articles={suggestedArticles}
          suggestedArticlesType={suggestedArticlesType}
        />
      </HelpContainer>
      {showCommunityFooter && <CommunityFooter />}
    </>
  );
};

HelpCenterWidget.model = helpCenterHomeWidgetModel;
export default HelpCenterWidget;
